import 'core-js/stable'
import 'regenerator-runtime/runtime'
import '../scss/style.scss'

import select from 'dom-select'
import throttle from 'lodash.throttle'
import SmoothScroll from 'smooth-scroll/dist/smooth-scroll.min'
import { tns } from "tiny-slider/src/tiny-slider"
import LazyLoad from 'lazyload/lazyload.min'
import YouTubePlayer from 'youtube-player'
import Player from '@vimeo/player/dist/player.min'
import Cookie from 'js-cookie'
import axios from 'axios'
const autocomplete = require('autocomplete.js');

import { classy as cl } from './helpers/classy'
import { scrollLock, scrollUnLock } from './helpers/scrollLock'
import Spoilers from './helpers/spoilers'
import videoResize from './helpers/videoResize'
import icons from './helpers/icons'
import fslightbox from 'fslightbox'
import Collapse from 'bootstrap.native/dist/components/collapse-native.esm.js';
import MatchHeight from './helpers/match-height'
import SlimSelect from 'slim-select';

export function inputs(parent) {
  select.all('.input', parent).forEach(input => {
    if (input.value !== '') input.classList.add('filled');
    input.addEventListener('focus', function() {
      input.classList.add('filled');
    });
    input.addEventListener('blur', function() {
      if (input.value === '') {
        input.classList.remove('filled');
      }
    });
    input.addEventListener('change', function() {
      input.classList.add('filled');
    });
  });

  select.all('form .slim-select, form .slim-select-wrapper select', parent).forEach(sse => {
        if (sse.tagName.toLowerCase() === 'select') {
          // Remove empty placeholder options
          const wrapper = sse.closest('.slim-select-wrapper');
          if (!wrapper || !wrapper.classList.contains('keep-placeholder')) {
            const emptyOptions = sse.querySelectorAll('option[value=""]');
            emptyOptions.forEach(opt => opt.remove());
          }
          
          new SlimSelect({
              select: sse,
              showSearch: true,
              showContent: 'down'
          })
        }
    });
  }


(function (doc, win) {
  require('viewport-units-buggyfill').init();
  window.openModal = false;
  window.dataLayer = window.dataLayer || [];
  const app = {};

  function scLock(target) {
    scrollLock(target, w => {
      const header = select('.header')
      if (header) { header.style.paddingRight = w+'px' }
    })
  }

  function scUnlock() {
    scrollUnLock(() => {
      const header = select('.header')
      if (header) { header.style.paddingRight = '' }
    })
  }

  function buttonStyles() {
    select.all('.button')
      .forEach(function(btn) {
        btn.innerHTML = '<span>'+btn.innerHTML+'</span>';
      });
  }

  const nav = function () {
    const burgers = select.all('.burger');
    const header = select('.header');
    const nav = select('.nav', header);
    const navitems = select.all('.nav > ul > li', header);

    function lock() {
      window.openModal = header;
      scLock(header)
    }

    function unlock() {
      window.openModal = false;
      scUnlock()
    }

    function resetNav() {
      cl(nav).rmCl('submenu-open');
      cl(navitems).rmCls('open');
    }

    burgers.forEach(burger => {
      burger.addEventListener('click', function () {
        if (burger.classList.contains('open')) { 
          resetNav()
          unlock() 
        } else { lock() }
        cl(header).toCl('open');
        cl(burgers).toCls('open');
      })
    })

    navitems.forEach(item => {
      const trig = select('a', item);
      const hasChildren = item.classList.contains('has-children');

      trig.addEventListener('click', ev => {
        // mobile menu
        if (header.classList.contains('open') && hasChildren) {
          // If this item is already open, check if clicking on "Back" area
          if (item.classList.contains('open')) {
            // Check if click is in the top area where "Back" appears (roughly first 40px)
            const rect = trig.getBoundingClientRect();
            const clickY = ev.clientY - rect.top;
            
            if (clickY < 40) {
              // Clicking "Back" - close submenu
              ev.preventDefault()
              ev.stopPropagation()
              resetNav()
              return;
            }
            // Otherwise, let the link work (go to the page)
            return;
          }
          // Otherwise, open the submenu
          ev.preventDefault()
          ev.stopPropagation()
          cl(nav).toCl('submenu-open');
          cl(navitems).rmCls('open');
          cl(item).toCl('open');
        } else if (win.matchMedia('(max-width: 1023.8px)').matches && hasChildren) {
          ev.preventDefault()
          ev.stopPropagation()
        }
      })
    })

    this.close = function () {
      if (header.classList.contains('open')) {
        cl(header).rmCl('open');
        cl(burgers).rmCls('open');
        resetNav()
        unlock()
      }
    }

    this.scroll = function () {
      const scrollDeep = 75;
      if (window.scrollY > scrollDeep && !header.classList.contains('is-compact')) {
        cl(header).addCl('is-compact')
      } else if (window.scrollY <= scrollDeep && header.classList.contains('is-compact')) {
        cl(header).rmCl('is-compact')
      }
    }
  };

  function activeNav() {
    const firstSegment = location.pathname.split('/')[1];
    const lastSegment = location.pathname.split('/').pop();
    select.all('.header a, .nav a, .footer a').forEach(function(nav) {
      const linkSegments = nav.pathname.split('/')
      const linkFirstSegment = linkSegments.length > 1 && linkSegments[1] !== '' ? linkSegments[1] : false
      const linkSecondSegment = linkSegments.length > 2 && linkSegments[2] !== '' ? linkSegments[2] : false

      if (linkSecondSegment && linkSecondSegment === lastSegment) cl(nav).addCl('active');
      else if (linkFirstSegment && !linkSecondSegment && linkFirstSegment === firstSegment) cl(nav).addCl('active');
      else cl(nav).rmCl('active');
    });
  }

  function smooth(el, offset, speed) {
    if (el) {
      const scroll = new SmoothScroll();
      scroll.animateScroll(el, false, {
        offset: offset || 200,
        updateURL: false,
        speed: speed || 600,
        durationMax: speed || 600
      });
    }
  }

  function setSmooth(parent) {
    select.all('.smooth-scroll', parent).forEach(anchor => {
      anchor.addEventListener('click', ev => {
        ev.preventDefault()
        ev.stopPropagation()
        if (anchor.dataset.window) {
          smooth(window.innerHeight, 0, 1000)
        } else {
          const target = select(anchor.hash)
          if (target) smooth(target, 76, 1000)
        }
      })
    })
  }

  const isEmpty = function(obj) {
    return Object.keys(obj).length === 0;
  };

  function setJuicerData(container, index) {
    const cols = select.all('.feed-post-tile', container)
    
    if (cols.length && !cols[0].classList.contains('loaded')) {
      // Fetch more posts and mix them
      axios.get(`https://www.juicer.io/api/feeds/${window.juicerFeedName}?per=30&page=1`).then(({ data }) => {
        const allPosts = data.posts.items || []
        
        // Group by source
        const bySource = {}
        allPosts.forEach(post => {
          const source = post.source.source
          if (!bySource[source]) bySource[source] = []
          bySource[source].push(post)
        })
        
        // Take posts from each source, round-robin style, skip unavailable content
        const mixedPosts = []
        const sources = Object.keys(bySource)
        let round = 0
        const maxRounds = 10
        
        while (mixedPosts.length < 6 && round < maxRounds) {
          let addedThisRound = false
          
          sources.forEach(source => {
            if (mixedPosts.length < 6 && bySource[source][round]) {
              const post = bySource[source][round]
              const message = post.message || post.unformatted_message || ''
              
              // Skip posts with unavailable content message
              if (message.includes("This content isn't available at the moment") || 
                  message.includes("This content isn't available")) {
                return
              }
              
              mixedPosts.push(post)
              addedThisRound = true
            }
          })
          
          if (!addedThisRound) break
          round++
        }
        
        data.posts.items = mixedPosts
        cols.forEach((p, i) => {
          const post = data.posts.items.length ? data.posts.items[i] : null
          
          if (!post) {
            // Hide empty boxes
            p.style.display = 'none'
            return
          }
          
          cl(p).addCl('loaded')
          
          const link = select('a', p)
            const imageDiv = select('.div-image', p)
            const polaroidImage = select('.polaroid-image', p)
            const message = select('.message', p)

            const postImage = post['image'] ? post['image'] : post['poster_image'] ? post['poster_image'] : ''
            const video = post['video'] && post['video'].indexOf('youtube') > -1 ? post['video'] : postImage && postImage.indexOf('.mp4') > -1 ? postImage : null

            // Set the link URL
            link.href = post.full_url

            // Handle video or image
            if (video) {
              cl(p).addCl('as-video')
              imageDiv.innerHTML = `
                <video src="${video}" autoplay muted playsinline loop></video>
              `
            } else {
              imageDiv.style.backgroundImage = `url('${postImage}')`
              imageDiv.innerHTML = `<img src="${postImage}">`
            }

            // Add social icon
            let iconHtml = ''
            switch (post.source.source) {
              case 'Instagram': iconHtml = icons.instagram; break;
              case 'Facebook':  iconHtml = icons.facebook; break;
              case 'YouTube':   iconHtml = icons.youtube; break;
              case 'Twitter':   iconHtml = icons.twitter; break;
              case 'LinkedIn':  iconHtml = icons.linkedin; break;
            }
            
            if (iconHtml) {
              polaroidImage.innerHTML += iconHtml
            }

            // Set the message/title - extract first line and clean it
            let messageText = post.message || post.unformatted_message || ''
            
            // Replace <br> tags with newlines before stripping HTML
            messageText = messageText.replace(/<br\s*\/?>/gi, '\n')
            
            // Strip HTML tags
            const tempDiv = document.createElement('div')
            tempDiv.innerHTML = messageText
            messageText = tempDiv.textContent || tempDiv.innerText || ''
            
            // Get first line (split by line breaks)
            const lines = messageText.split(/\n+/).map(line => line.trim()).filter(line => line.length > 0)
            const firstLine = lines[0] || ''
            
            // Remove emojis (all emoji ranges)
            const cleanText = firstLine.replace(/[\u{1F000}-\u{1F9FF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]|[\u{FE00}-\u{FE0F}]|[\u{1F900}-\u{1F9FF}]|[\u{1FA00}-\u{1FA6F}]|[\u{1FA70}-\u{1FAFF}]|[\u{E0020}-\u{E007F}]/gu, '').trim()
            
            // Truncate to 50 characters
            const displayText = cleanText.length > 50 
              ? cleanText.substring(0, 50) + '...' 
              : cleanText
            
          message.innerHTML = displayText || post.poster_name || post.source.source + ' post'
        })
        
        // Trigger MatchHeight recalculation after content is loaded
        setTimeout(() => {
          MatchHeight()
        }, 100)
      })
    }
  }

  function matchBannerHeights() {
    select.all('.swiper-container').forEach(container => {
      const slides = select.all('.swiper-slide', container)
      if (slides.length > 1) {
        // Get the tallest non-video-overlay banner height
        let maxHeight = 0
        slides.forEach(slide => {
          const videoBanner = select('.banner--video-overlay', slide)
          if (!videoBanner) {
            const banner = select('.banner', slide)
            if (banner) {
              const height = banner.offsetHeight
              if (height > maxHeight) maxHeight = height
            }
          }
        })
        
        // Apply to all video overlay banners if we found a max height
        if (maxHeight > 0) {
          slides.forEach(slide => {
            const videoBanner = select('.banner--video-overlay', slide)
            if (videoBanner) {
              videoBanner.style.height = maxHeight + 'px'
            }
          })
        }
      }
    })
  }

  app.sliders = [];
  app.listSliders = [];
  function swipers(parent) {
    app.sliders.forEach(sl => {
      if ( sl.destroy ) {
        sl.destroy()
      }
    });
    app.listSliders.forEach(sl => sl.destroy());
    if ( win.matchMedia('(max-width: 1023.98px)').matches ) {
      select.all('.section--list, .section--images', parent).forEach(sl => {
        app.listSliders.push(
          tns({
            container: select('.slider', sl),
            items: 1,
            slideBy: 'page',
            controls: false,
            speed: 400,
            autoplay: true,
            autoplayButtonOutput: false,
            loop: false,
            swipeAngle: false,
            mouseDrag: !!sl.classList.contains('--list'),
            navPosition: 'bottom',
            responsive: {
              576: {
                items: 2,
                edgePadding:20,
                gutter: 20,
              },
              900: {
                items: 4,
              }
            }
          })
        );
      });
    }
      
    select.all('.swiper-regular', parent).forEach(sw => {
      let speed = Number(sw.dataset.speed) || 1000;
      let autoplay = Number(sw.dataset.autoplay) || true;
      app.sliders.push(
        tns({
          container: select('.swiper-wrapper', sw),
          items: 1,
          slideBy: 'page',
          controls: false,
          speed: speed,
          autoplay: !!autoplay,
          autoplayTimeout: autoplay ? 4000 : 0,
          autoplayHoverPause: true,
          autoplayButtonOutput: false,
          loop: true,
          swipeAngle: false,
          mouseDrag: true,
          navPosition: 'bottom'
        })
      )

    })
    
    // Match banner heights after sliders are initialized
    setTimeout(() => {
      matchBannerHeights()
    }, 100)
  }

  function swipersResize() {
    if ( win.matchMedia('(max-width: 1023.98px)').matches ) {
      if ( app.listSliders.length == 0 ) {
        select.all('.section--list, .section--images', doc).forEach(sl => {
          app.listSliders.push(
            tns({
              container: select('.slider', sl),
              items: 1,
              slideBy: 'page',
              controls: false,
              speed: 400,
              autoplay: true,
              autoplayButtonOutput: false,
              loop: false,
              swipeAngle: false,
              mouseDrag: !!sl.classList.contains('--list'),
              navPosition: 'bottom',
              responsive: {
                576: {
                  items: 2,
                  edgePadding:20,
                  gutter: 20,
                },
                900: {
                  items: 4,
                }
              }
            })
          );
        });
        setGallery(doc);
      }
    } else {
      if ( app.listSliders.length > 0 ) {
        app.listSliders.forEach( sl => typeof sl.destroy === 'function' ? sl.destroy() : '' );
        app.listSliders = [];
        setGallery(doc);
      }
    }
  }

  function iframeVideos(parent) {
    return select.all('.iframe-video', parent).map(videoWrap => {
      const videoId = videoWrap.dataset.videoId
      const videoType = videoWrap.dataset.videoType
      let pl = null;

      if (videoType === 'youtube') {
        const player = YouTubePlayer(videoWrap, { videoId });
        if (player) {
          pl = {
            wrap: videoWrap.parentNode,
            play() { player.playVideo() },
            pause() { player.pauseVideo() }
          }
        }
      } else if (videoType === 'vimeo') {
        const player = new Player(videoWrap, { id: videoId });
        if (player) {
          pl = {
            wrap: videoWrap.parentNode,
            play() { player.play() },
            pause() { player.pause() }
          }
        }
      }

      return pl;
    })
  }

  function openModal(modal) {
    if (window.activeModal) {
      closeModal(window.activeModal)
    }
    if (!modal.open) {
      modal.open = true
      window.activeModal = modal
      cl(modal.modal).addCl('open')
      scLock(modal.modal)
      if (modal.videos.length) {
        modal.videos.forEach(v => {
          if (v.wrap.closest('.swiper-slide-active')) {
            v.play()
          } else if (!v.wrap.closest('.swiper-slide')) {
            v.play()
          }
        })
      }
    }
    if (modal.modal.classList.contains('gallery-modal') && app.swipers.length) {
      setTimeout(() => {
        app.swipers.forEach(m => (m.update()))
      }, 400)
    }
  }

  function closeModal(modal) {
    if (modal.open) {
      modal.open = false
      window.activeModal = null
      cl(modal.modal).rmCl('open')
      setTimeout(() => {
        modal.modal.scrollTo(0, 0)
        scUnlock()
      }, 300)
      if (modal.videos.length) {
        modal.videos.forEach(v => (v.pause()))
      }
      if (modal.delayed) {
        Cookie.set('modal-closed-' + modal.name, 'closed', { expires: modal.cookieTime })
      }
    }
  }

  const initializedGalleryLinks = new WeakSet()
  let galleryCaptions = {}
  let activeGalleryName = null
  let galleryCleanup = null
  let fsLightboxSignature = null
  let shownCaptionIndex = -1

  function removeGalleryCaption() {
    const caption = document.querySelector('.fslightbox-container .custom-caption')
    if (caption) caption.remove()
  }

  function cleanupGallery() {
    if (galleryCleanup) galleryCleanup()
    galleryCleanup = null
    shownCaptionIndex = -1
    removeGalleryCaption()
  }

  function currentGallerySlide() {
    const instance = activeGalleryName && window.fsLightboxInstances && window.fsLightboxInstances[activeGalleryName]
    return instance && instance.stageIndexes ? instance.stageIndexes.current : -1
  }

  function updateGalleryCaption() {
    const lightbox = document.querySelector('.fslightbox-container')
    if (!lightbox || !activeGalleryName) return

    const index = currentGallerySlide()
    if (index === shownCaptionIndex) return

    shownCaptionIndex = index
    removeGalleryCaption()

    const captions = galleryCaptions[activeGalleryName]
    const currentCaption = captions && captions[index]

    if (currentCaption) {
      const caption = document.createElement('div')
      caption.className = 'custom-caption'
      caption.style.cssText = 'position: absolute; bottom: 20px; left: 50%; transform: translateX(-50%); background: rgba(0,0,0,0.7); color: white; padding: 10px 20px; border-radius: 4px; font-size: 14px; max-width: 80%; text-align: center; z-index: 10000; pointer-events: none;'
      caption.textContent = currentCaption
      lightbox.appendChild(caption)
    }
  }

  function initGalleryCaption() {
    cleanupGallery()

    const lightbox = document.querySelector('.fslightbox-container')
    if (!lightbox || !activeGalleryName) return

    updateGalleryCaption()

    // FsLightbox has no slide change callback, so read its own slide index after anything
    // that can change the slide: the arrow buttons, the keyboard, and swipes. A swipe ends
    // in a pointerup on document, and this listener is added after FsLightbox's own one, so
    // the index is already updated. Counting navigation events instead misses swipes.
    const syncCaption = () => updateGalleryCaption()

    lightbox.addEventListener('click', syncCaption)
    document.addEventListener('keydown', syncCaption)
    document.addEventListener('pointerup', syncCaption)
    galleryCleanup = () => {
      lightbox.removeEventListener('click', syncCaption)
      document.removeEventListener('keydown', syncCaption)
      document.removeEventListener('pointerup', syncCaption)
    }
  }

  function setGallery(parent) {
    const links = select.all('[data-fslightbox]', doc)
    const captions = {}

    links.forEach(link => {
      const galleryName = link.getAttribute('data-fslightbox');
      if (!captions[galleryName]) {
        captions[galleryName] = [];
      }
      captions[galleryName].push(link.dataset.caption || '');
      link.setAttribute('data-fslightbox-index', captions[galleryName].length - 1);

      if (!initializedGalleryLinks.has(link)) {
        link.addEventListener('click', () => {
          activeGalleryName = link.getAttribute('data-fslightbox')
        }, true)
        initializedGalleryLinks.add(link)
      }
    })

    galleryCaptions = captions

    const nextSignature = links.map(link => `${link.getAttribute('data-fslightbox')}:${link.href}`).join('|')
    if (nextSignature !== fsLightboxSignature) {
      cleanupGallery()
      refreshFsLightbox()
      fsLightboxSignature = nextSignature
    }

    Object.keys(galleryCaptions).forEach(galleryName => {
      const instance = window.fsLightboxInstances && window.fsLightboxInstances[galleryName]
      if (instance) {
        instance.props.onOpen = () => setTimeout(initGalleryCaption, 0)
        instance.props.onClose = cleanupGallery
      }
    })
    
    select.all('.gallery .card', parent).forEach(card => {
      // Handle Vimeo videos
      if (card.dataset.modalVimeoId && !card.dataset.vimeoInitialized) {
        card.dataset.vimeoInitialized = 'true'
        card.addEventListener('click', ev => {
          ev.preventDefault()
          ev.stopPropagation()
          openVimeoModal(card.dataset.modalVimeoId)
        })
      } else if (!card.dataset.modalVimeoId) {
        card.addEventListener('click', ev => {
          ev.preventDefault()
          ev.stopPropagation()
        })
      }
    })
  }

  function openVimeoModal(videoId) {
    // Create modal HTML
    const modalHtml = `
      <div class="vimeo-modal-overlay" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.95); z-index: 10000; display: flex; align-items: center; justify-content: center; padding: 20px;">
        <div class="vimeo-modal-content" style="position: relative; width: 100%; max-width: 1200px; aspect-ratio: 16/9;">
          <button class="vimeo-modal-close" style="position: absolute; top: -50px; right: 0; background: none; border: none; color: white; font-size: 40px; cursor: pointer; z-index: 10001; padding: 10px; line-height: 1;">&times;</button>
          <div id="vimeo-player-container" style="width: 100%; height: 100%; background: #000;"></div>
        </div>
      </div>
    `
    
    // Add modal to body
    const modalDiv = document.createElement('div')
    modalDiv.innerHTML = modalHtml
    document.body.appendChild(modalDiv.firstElementChild)
    
    const overlay = document.querySelector('.vimeo-modal-overlay')
    const closeBtn = document.querySelector('.vimeo-modal-close')
    const playerContainer = document.getElementById('vimeo-player-container')
    
    // Initialize Vimeo player with responsive 16:9
    const player = new Player(playerContainer, {
      id: videoId,
      responsive: true
    })
    
    // Close handlers
    const closeModal = (e) => {
      if (e) {
        e.preventDefault()
        e.stopPropagation()
      }
      player.destroy()
      overlay.remove()
      scUnlock()
    }
    
    closeBtn.addEventListener('click', closeModal)
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) closeModal(e)
    })
    
    const escHandler = (e) => {
      if (e.key === 'Escape') {
        closeModal()
        document.removeEventListener('keydown', escHandler)
      }
    }
    document.addEventListener('keydown', escHandler)
    
    scLock(overlay)
    player.play()
  }

  function setModals(parent) {
    window.modals = []
    select.all('[data-modal]', parent).forEach(modal => {
      const videos = iframeVideos(modal);
      const open = modal.classList.contains('open')
      const name = modal.dataset.modal
      const delayed = modal.dataset.modalDelayed ? Number(modal.dataset.modalDelayed) : null
      const cookieTime = modal.dataset.modalCookieTime ? Number(modal.dataset.modalDelayed) : null

      const modalEl = { name, modal, videos, open, delayed, cookieTime }
      window.modals.push({
        ...modalEl,
        open() { openModal(modalEl) },
        close() { closeModal(modalEl) }
      })

      select.all('.close, .modal-back, .close-button', modal).forEach(cl => {
        cl.addEventListener('click', ev => {
          ev.preventDefault()
          ev.stopPropagation()
          closeModal(modalEl)
        })
      })

      if (delayed && !Cookie.get('modal-closed-'+modalEl.name)) {
        setTimeout(() => {
          openModal(modalEl)
        }, delayed*1000)
      }
    })

    select.all('[data-modal-target], a[href*="#modal-"]', parent).forEach(trigger => {
      const target = trigger.dataset.modalTarget ? window.modals.find(m => m.name === trigger.dataset.modalTarget) : window.modals.find(m => m.name === trigger.hash.split('modal-').pop())
      if (target) {
        trigger.addEventListener('click', ev => {
          ev.preventDefault()
          ev.stopPropagation()
          target.open()
        })
      }
    })
  }

  

  app.lazyload = null
  function setLazy(parent) {
    if (app.lazyload) app.lazyload.destroy();
    const images = select.all('[data-src]', parent)
    app.lazyload = new LazyLoad(images)
  }

  function initNav() {
    app.nav = new nav()
  }

  function initStickyNav() {
    import( /* webpackChunkName: "stickyNav" */ './modules/stickyNav.js').then(({ default: stickyNav }) => {
      stickyNav()
    }).catch(error => console.error('Error loading stickyNav:', error))
  }

  function searchMembers(parent) {
    if ( parent.querySelector( '.section--full-list' ) ) { 
      return import( /* webpackChunkName: "searchMembers" */ './modules/searchMembers.js').then( ( { default: searchMembers } ) => {
        searchMembers( parent )
      }).catch(error => 'An error occurred while loading the component');
    }
  }

  function frontendMemberForms(parent) {
    if ( parent.querySelector( '.member-edit, .section-member-form' ) ) { 
      return import( /* webpackChunkName: "frontendMemberForms" */ './modules/frontendMemberForms.js' ).then( ( { default: frontendMemberForms } ) => {
        frontendMemberForms()
      }).catch(error => 'An error occurred while loading the component');
    }
  }

  function myaccountMenu() {
    const myAccountMenu = doc.getElementById( 'my-account-menu' )
    if ( myAccountMenu ) {
      new Collapse('#my-account-menu');
    }
  }

  app.videRes = null
  function initJuicer(parent) {
    const juicerSection = select('.section-social', parent)
    
    if (juicerSection && window.juicerFeedName) {
      setJuicerData(juicerSection, 0)
    }
  }

  function initObfuscatedEmails(parent) {
    select.all('.obfuscated-email', parent).forEach(link => {
      const encoded = link.dataset.email
      if (encoded) {
        const decoded = atob(encoded)
        // Display the actual email address
        link.textContent = decoded
        link.href = 'mailto:' + decoded
        link.onclick = null
      }
    })
  }

  function initPage(parent) {
    activeNav()
    if (parent) {
      swipers(parent)
      setSmooth(parent)
      setLazy(parent)
      setGallery(parent)
      setModals(parent)
      inputs(parent)
      app.spoilers = new Spoilers(parent)
      app.videRes = new videoResize('.has-cover-video')
      searchMembers(parent)
      frontendMemberForms(parent)
      myaccountMenu()
      initJuicer(parent)
      initObfuscatedEmails(parent)
    }
    MatchHeight()
  
    // Ensure MatchHeight runs after all images/resources finish loading
    window.addEventListener('load', () => {
      if (typeof MatchHeight === 'function') {
        MatchHeight();
      }
    });
  }

  doc.addEventListener('DOMContentLoaded', function () {
    buttonStyles();
    
    initNav();
    initStickyNav();
    initPage(doc);
    
    if (app.nav) app.nav.scroll();

    win.addEventListener('scroll', throttle(function () {
      if (app.nav) app.nav.scroll();
    }, 50));

    win.addEventListener('resize', throttle(function () {
      if (app.nav) app.nav.close();
      if (app.videRes) app.videRes.resize();
      swipersResize()
      matchBannerHeights()
    }, 300));

    win.addEventListener('keydown', ev => {
      if (ev.key === "Escape") {
        if (app.nav) app.nav.close();
        window.modals.forEach(m => (m.close()))
        cl('.block-search.is-global').rmCl('show-search')
      }
    })
  })
})(document, window);
